import React, { useState } from "react";
import DatePicker from "../FormComponents/DatePicker";
import RadioBox from "../FormComponents/RadioBox";
import { TextField, Button, FormHelperText } from "@material-ui/core";
import { FieldArray } from "formik";
import { uniqId } from "../../utils/commonHelpers";
import { getIn } from "formik";
import { Number } from "../../utils/Number";
import { TextMaskCustom } from "../../utils/TextMaskCustom";
import AutoCompleteStates from "../FormComponents/AutoCompleteStates";
import AutoCompleteRelations from "../FormComponents/AutoCompleteRelations";

const PrimaryField = ({ values, touched, handleChange, errors, setFieldValue, setPrimaryHealth }) => {
  const [otherField, setOtherField] = useState({});

  return (
    <div className="card custom-card">
      <div className="title">
        <h5>HEALTH INSURANCE INFORMATION</h5>
      </div>
      <div className="primary-health">
        <div className="row align-items-center">
          <div className="col-lg-4">
            <p>Do you have Health Insurance?</p>
          </div>
          <div className="col-lg-8">
            <RadioBox
              name="primaryHealth"
              value={values.primaryHealth}
              label={["Yes", "No"]}
              handleChange={(e) => {
                handleChange(e);
                setPrimaryHealth(e.target.value);
              }}
            />
          </div>
        </div>

        {values.primaryHealth === "Yes" && (
          <div>
            <div className="title">
              <p>
                In case another source does not pay this claim, we may need to bill your health
                insurance.
              </p>
              <p>
                {" "}
                Please fill out this section, including Medicare and/or Medicaid information.
                {/* or attach a
                copy (front and back) of your insurance card */}
              </p>
            </div>

            <div className="row mx-0">
              <FieldArray name="healthInsurances">
                {(insuranceProps) => {
                  const { push, remove, form } = insuranceProps;
                  const { values } = form;
                  const { healthInsurances } = values;

                  return (
                    <div>
                      {healthInsurances.map((insurance, index) => {
                        return (
                          <div
                            key={insurance.id}
                            className={index < healthInsurances.length - 1 ? "border-btm-field" : ""}
                          >
                            <div className="row mx-0">
                              <div className="col-12 px-0 mt-3">
                                <div className="row my-3">
                                  <div className="form-group col-md-6 col-lg-4">
                                    <TextField
                                      label="Insurance Name"
                                      name={`healthInsurances[${index}].insurerName`}
                                      onChange={handleChange}
                                      aria-label="text-field"
                                      fullWidth
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                      inputProps={{ maxLength: 50 }}
                                      error={Boolean(
                                        getIn(touched, `healthInsurances[${index}].insurerName`) &&
                                          getIn(errors, `healthInsurances[${index}].insurerName`)
                                      )}
                                      helperText={
                                        getIn(touched, `healthInsurances[${index}].insurerName`) &&
                                        getIn(errors, `healthInsurances[${index}].insurerName`) && (
                                          <span style={{ fontWeight: 400 }}>
                                            {" "}
                                            {getIn(errors, `healthInsurances[${index}].insurerName`)}
                                          </span>
                                        )
                                      }
                                      required
                                    />
                                  </div>

                                  <div className="form-group col-md-6 col-lg-4">
                                    <TextField
                                      label="Policyholder Name"
                                      name={`healthInsurances[${index}].policyHolderName`}
                                      onChange={handleChange}
                                      // value={values[name]}
                                      aria-label="text-field"
                                      fullWidth
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                      inputProps={{ maxLength: 50 }}
                                      error={Boolean(
                                        getIn(touched, `healthInsurances[${index}].policyHolderName`) &&
                                          getIn(errors, `healthInsurances[${index}].policyHolderName`)
                                      )}
                                      helperText={
                                        getIn(touched, `healthInsurances[${index}].policyHolderName`) &&
                                        getIn(errors, `healthInsurances[${index}].policyHolderName`) && (
                                          <span style={{ fontWeight: 400 }}>
                                            {" "}
                                            {getIn(
                                              errors,
                                              `healthInsurances[${index}].policyHolderName`
                                            )}{" "}
                                          </span>
                                        )
                                      }
                                      required
                                      // margin="dense"
                                    />
                                  </div>
                                  <div className="form-group col-md-6 col-lg-4">
                                    <DatePicker
                                      name={`healthInsurances[${index}].policyHolderDateOfBirth`}
                                      label={"Policyholder Date of Birth"}
                                      value={values.healthInsurances[`${index}`].policyHolderDateOfBirth}
                                      error={Boolean(
                                        getIn(
                                          touched,
                                          `healthInsurances[${index}].policyHolderDateOfBirth`
                                        ) &&
                                          getIn(
                                            errors,
                                            `healthInsurances[${index}].policyHolderDateOfBirth`
                                          )
                                      )}
                                      required
                                      disableFuture={true}
                                      //required={false}
                                    />
                                    <FormHelperText>
                                      {Boolean(
                                        getIn(
                                          touched,
                                          `healthInsurances[${index}].policyHolderDateOfBirth`
                                        ) &&
                                          getIn(
                                            errors,
                                            `healthInsurances[${index}].policyHolderDateOfBirth`
                                          )
                                      ) && (
                                        <span style={{ color: "#F44336", fontWeight: 400 }}>
                                          {getIn(
                                            errors,
                                            `healthInsurances[${index}].policyHolderDateOfBirth`
                                          )}
                                        </span>
                                      )}{" "}
                                    </FormHelperText>
                                  </div>

                                  <div className="form-group col-md-6 col-lg-4 text-overlaping">
                                    <AutoCompleteRelations
                                      label="Policyholder Relationship to the Patient"
                                      name={`healthInsurances[${index}].patientRelationship`}
                                      onChange={(e, value) => {
                                        if (value) {
                                          console.log(
                                            value,
                                            healthInsurances[index].patientRelationship,
                                            values.healthInsurances[`${index}`].patientRelationship
                                          );
                                          setFieldValue(
                                            `healthInsurances[${index}].patientRelationship`,
                                            value.value
                                          );
                                          // Taking the field name along with the index
                                          let fieldName = `field${index}`;
                                          // Setting the field value to true or false based on other selection
                                          if (value.label === "Other") {
                                            setOtherField({ ...otherField, [fieldName]: true });
                                          } else {
                                            setOtherField({ ...otherField, [fieldName]: false });
                                          }
                                        } else {
                                          setFieldValue(
                                            `healthInsurances[${index}].patientRelationship`,
                                            ""
                                          );
                                        }
                                      }}
                                      value={values[`healthInsurances[${index}].patientRelationship`]}
                                      aria-label="auto-complete"
                                      fullWidth
                                    />
                                  </div>

                                  {otherField[`field${index}`] ? (
                                    <div className="form-group col-md-6 col-lg-4 text-overlaping">
                                      <TextField
                                        label="Please specify relationship"
                                        name={`healthInsurances[${index}].patientRelationship`}
                                        onChange={handleChange}
                                        // value={values[name]}
                                        aria-label="text-field"
                                        fullWidth
                                        InputLabelProps={{
                                          shrink: true,
                                        }}
                                        inputProps={{ maxLength: 35 }}
                                        // margin="dense"
                                      />
                                    </div>
                                  ) : null}

                                  <div className="form-group col-md-6 col-lg-4">
                                    <TextField
                                      label="Member ID"
                                      name={`healthInsurances[${index}].policyNo`}
                                      onChange={handleChange}
                                      // value={values[name]}
                                      aria-label="text-field"
                                      fullWidth
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                      inputProps={{ maxLength: 35 }}
                                      error={Boolean(
                                        getIn(touched, `healthInsurances[${index}].policyNo`) &&
                                          getIn(errors, `healthInsurances[${index}].policyNo`)
                                      )}
                                      helperText={
                                        getIn(touched, `healthInsurances[${index}].policyNo`) &&
                                        getIn(errors, `healthInsurances[${index}].policyNo`) && (
                                          <span style={{ fontWeight: 400 }}>
                                            {" "}
                                            {getIn(errors, `healthInsurances[${index}].policyNo`)}{" "}
                                          </span>
                                        )
                                      }
                                      required
                                      // margin="dense"
                                    />
                                  </div>
                                  <div className="form-group col-md-6 col-lg-4">
                                    <TextField
                                      label="Group Number"
                                      name={`healthInsurances[${index}].groupId`}
                                      onChange={handleChange}
                                      // value={values[name]}
                                      aria-label="text-field"
                                      fullWidth
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                      inputProps={{ maxLength: 35 }}
                                      // margin="dense"
                                    />
                                  </div>
                                  <div className="form-group col-md-6 col-lg-4">
                                    <TextField
                                      label="Address"
                                      name={`healthInsurances[${index}].addressLine1`}
                                      onChange={handleChange}
                                      aria-label="text-field"
                                      fullWidth
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                      inputProps={{ maxLength: 50 }}
                                    />
                                  </div>
                                  <div className="form-group col-md-6 col-lg-4">
                                    <TextField
                                      label="City"
                                      name={`healthInsurances[${index}].city`}
                                      onChange={handleChange}
                                      // value={values[name]}
                                      aria-label="text-field"
                                      fullWidth
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                      inputProps={{ maxLength: 35 }}
                                      // margin="dense"
                                    />
                                  </div>
                                  <div className="form-group col-md-6 col-lg-4">
                                    {/* <TextField
                                      label="State"
                                      name={`healthInsurances[${index}].state`}
                                      onChange={handleChange}
                                      // value={values[name]}
                                      aria-label="text-field"
                                      fullWidth
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                      // margin="dense"
                                    /> */}

                                    <AutoCompleteStates
                                      label="State"
                                      name={`healthInsurances[${index}].state`}
                                      onChange={(e, value) => {
                                        if (value) {
                                          setFieldValue(`healthInsurances[${index}].state`, value.code);
                                        } else {
                                          setFieldValue(`healthInsurances[${index}].state`, "");
                                        }
                                      }}
                                      value={values[`healthInsurances[${index}].state`]}
                                      aria-label="auto-complete"
                                      fullWidth
                                      error={Boolean(
                                        getIn(touched, `healthInsurances[${index}].state`) &&
                                          getIn(errors, `healthInsurances[${index}].state`)
                                      )}
                                      helperText={
                                        getIn(touched, `healthInsurances[${index}].state`) &&
                                        getIn(errors, `healthInsurances[${index}].state`) &&
                                        getIn(errors, `healthInsurances[${index}].state`)
                                      }
                                      required={false}
                                    />
                                  </div>
                                  <div className="form-group col-md-6 col-lg-4">
                                    <TextField
                                      label="ZIP Code"
                                      name={`healthInsurances[${index}].zipCode`}
                                      onChange={handleChange}
                                      // value={values[name]}
                                      aria-label="text-field"
                                      InputProps={{
                                        inputComponent: Number,
                                      }}
                                      inputProps={{ maxLength: 5 }}
                                      fullWidth
                                      error={Boolean(
                                        getIn(touched, `healthInsurances[${index}].zipCode`) &&
                                          getIn(errors, `healthInsurances[${index}].zipCode`)
                                      )}
                                      helperText={
                                        getIn(touched, `healthInsurances[${index}].zipCode`) &&
                                        getIn(errors, `healthInsurances[${index}].zipCode`) &&
                                        getIn(errors, `healthInsurances[${index}].zipCode`)
                                      }
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                      // margin="dense"
                                    />
                                  </div>

                                  <div className="form-group col-md-6 col-lg-4">
                                    <TextField
                                      label="Phone"
                                      name={`healthInsurances[${index}].phone`}
                                      onChange={handleChange}
                                      InputProps={{
                                        inputComponent: TextMaskCustom,
                                      }}
                                      // value={values[name]}
                                      aria-label="text-field"
                                      fullWidth
                                      error={Boolean(
                                        getIn(touched, `healthInsurances[${index}].phone`) &&
                                          getIn(errors, `healthInsurances[${index}].phone`)
                                      )}
                                      helperText={
                                        getIn(touched, `healthInsurances[${index}].phone`) &&
                                        getIn(errors, `healthInsurances[${index}].phone`) &&
                                        getIn(errors, `healthInsurances[${index}].phone`)
                                      }
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                      // margin="dense"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="row mx-0">
                              {
                                <Button
                                  className="add-btn mb-4"
                                  margin="normal"
                                  type="button"
                                  color="primary"
                                  variant="outlined"
                                  hidden={index === 0}
                                  onClick={() => remove(index)}
                                >
                                  {/* <DeleteOutlinedIcon /> */} delete
                                </Button>
                              }
                            </div>
                          </div>
                        );
                      })}
                      <div className="row mx-0">
                        <div className="col-12 text-center">
                          <Button
                            className={
                              healthInsurances && healthInsurances.length >= 4
                                ? "add-btn-disabled mt-3"
                                : "add-btn mt-3 "
                            }
                            margin="normal"
                            type="button"
                            color="primary"
                            variant="outlined"
                            // type="button"
                            disabled={healthInsurances && healthInsurances.length >= 4}
                            onClick={() =>
                              push({
                                id: uniqId(),
                                insurerName: "",
                                addressLine1: "",
                                policyHolderDateOfBirth: null,
                                policyHolderName: "",
                                city: "",
                                state: "",
                                zipCode: "",
                                patientRelationship: "",
                                phone: "",
                                policyNo: "",
                                groupId: "",
                              })
                            }
                          >
                            Add Insurance +
                          </Button>
                        </div>
                      </div>
                    </div>
                  );
                }}
              </FieldArray>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default React.memo(PrimaryField);
